import React from 'react';
import classnames from 'classnames';
import JournalDumbView from '../../../../DeviationViews/Dumbo/Journal';
import EditorDeviationLink from '../../_partials/DeviationLink';
import { getSizeForFreeform } from '../../helpers';
import s from './Journal.scss';
var JournalMonoReactView = function (_a) {
    var _b = _a.config, alignment = _b.alignment, link = _b.link, configuredWidth = _b.width, settings = _a.settings, deviation = _a.deviation;
    var size = {
        width: 389,
        height: 343,
    };
    if (alignment !== 'center') {
        size = {
            width: 350,
            height: 313,
        };
    }
    // Handle resizing
    size = getSizeForFreeform(size, configuredWidth);
    if (settings && settings.showMediaAlwaysSmall) {
        // https://zpl.io/awYRXAn
        size = {
            width: 180,
            height: 125,
        };
    }
    return (React.createElement("div", { className: classnames(s['root'], s['normal'], alignment && s[alignment], settings && settings.showMediaAlwaysSmall && s['small']), style: { width: size.width } },
        React.createElement(EditorDeviationLink, { link: link, deviation: deviation, linkClass: "gallery-link" },
            React.createElement(JournalDumbView, { width: size.width, height: size.height, deviation: deviation }))));
};
JournalMonoReactView.displayName = 'JournalMonoReactView';
export default JournalMonoReactView;
//# sourceMappingURL=Journal.js.map